const LOCALE_STORAGE_KEY = 'sp_locale';

export function getHostname() {
    if (typeof window === 'undefined') return 'sportprogress.ru';
    return window.location.hostname.replace(/^www\./, '');
}

export function getDomainKey() {
    const host = getHostname();
    if (host.includes('sportprogress.ru')) return 'sportprogress.ru';
    if (host.includes('sportprogress.app')) return 'sportprogress.app';
    if (host.includes('sportprogress.online')) return 'sportprogress.online';
    return 'localhost';
}

export function isRussianDomain() {
    return getDomainKey() === 'sportprogress.ru';
}

export function isInternationalDomain() {
    const key = getDomainKey();
    return key === 'sportprogress.app' || key === 'sportprogress.online';
}

export function isEuropeDomain() {
    return getDomainKey() === 'sportprogress.online';
}
